import { type JSX } from 'react';
import { IconBase, type IconProps } from '@doxyme/icons';

export const Gmail = (props: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 44 34' width={44} height={34} {...props}>
    <g clip-path='url(#clip0_18117_29855)'>
      <path
        d='M3 33.5H10V16.5L0 9V30.5C0 32.16 1.345 33.5 3 33.5Z'
        fill='#4285F4'
      />
      <path
        d='M34 33.5H41C42.66 33.5 44 32.155 44 30.5V9L34 16.5'
        fill='#34A853'
      />
      <path
        d='M34 3.49997V16.5L44 8.99997V4.99997C44 1.28997 39.765 -0.825034 36.8 1.39997'
        fill='#FBBC04'
      />
      <path d='M10 16.5V3.5L22 12.5L34 3.5V16.5L22 25.5' fill='#EA4335' />
      <path
        d='M0 4.99997V8.99997L10 16.5V3.49997L7.2 1.39997C4.23 -0.825034 0 1.28997 0 4.99997Z'
        fill='#C5221F'
      />
    </g>
    <defs>
      <clipPath id='clip0_18117_29855'>
        <rect
          width='44'
          height='33'
          fill='white'
          transform='translate(0 0.5)'
        />
      </clipPath>
    </defs>
  </IconBase>
);
